import { useContext, useMemo } from 'react'
import { useGetAllTemplates } from './tableKeeper'
import { ProjectContext } from 'src/context/project/ProjectContext'
import useMigrateStore from 'src/components/migrate/useMigrateStore'

export const useTemplateProjectId = () => {
  const { templateId, destinationProjectId } = useMigrateStore()
  const { data: templates = [] } = useGetAllTemplates()
  const { projects } = useContext(ProjectContext).state

  const templateProject = useMemo(() => {
    const selectedTemplate = templates.find((t) => t.id === templateId)
    if (!selectedTemplate) return undefined
    return projects.find((p) => `${p.id}` === selectedTemplate.projectId)
  }, [projects, templates, templateId])

  const selectedTemplate = useMemo(() => {
    return templates.find((t) => t.id === templateId)
  }, [templates, templateId])

  const destinationProject = useMemo(() => {
    return projects.find((p) => p.id === destinationProjectId)
  }, [projects, destinationProjectId])

  const templatesWithProject = useMemo(() => {
    return templates.map((template) => {
      const project = projects.find((p) => `${p.id}` === template.projectId)
      return {
        ...template,
        projectName: project?.projectName || 'Unknown Project',
      }
    })
  }, [templates, projects])

  return {
    selectedTemplate,
    projects,
    templateProject,
    templateProjectId: templateProject?.id,
    templates: templatesWithProject,
    destinationProject,
  }
}
